import { NavLink, generatePath } from 'react-router-dom';
import { IconLoader } from '@ui/src';
import ROUTES from '../../routes';
import { ColumnItems } from './types';
import ColumnHead from './column-head';

import cn from './column.module.css';

interface ColumnBanksProps {
  banks: ColumnItems[];
  isLoading: boolean;
  onClearAccountState: () => void;
}

const ColumnBanks = ({
  banks,
  isLoading,
  onClearAccountState,
}: ColumnBanksProps): React.JSX.Element => (
  <div className={cn.column}>
    <ColumnHead title="Bank" />

    {isLoading ? (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    ) : (
      banks?.map((item) => (
        <div className={cn.columnItemWrapper} key={item.id}>
          <NavLink
            className={`${cn.columnItem} ${item.isNew ? cn.badge : ''}`}
            to={generatePath(ROUTES.EXPORT_BANKS, { bankId: item.id })}
            onClick={onClearAccountState}
          >
            {item.name}
          </NavLink>
        </div>
      ))
    )}
  </div>
);

export default ColumnBanks;
